// Selectors ==========================================================================================================================================================================
let myTrgBtnSubmit = document.querySelector(".my-tgr-btn-submit");
let myInputSearch = document.getElementById("clinicId");
let myResultFrame = document.querySelector(".my-result-frame");
let myNoResultFrame = document.querySelector(".my-no-result-frame");
let myResultCode = document.querySelector(".my-result-code");
let clinicResult = document.getElementById("clinicResult");
let myCollapseBtnResult = document.querySelector(".my-collapse-btn-result");
// let myCloseBtnResult = document.querySelector(".my-close-btn-result");
let myCloseBtnNoResult = document.querySelector(".my-close-btn-no-result");
let loaderWrapper = document.querySelector(".loader-wrapper");
let myErrorMsg = document.querySelector(".my-error-msg");

// Expand/collapse result
myCollapseBtnResult.addEventListener('click', () => {
    myCollapseBtnResult.classList.toggle('fa-circle-plus')
    myResultCode.classList.toggle('d-none')
});

// Close result frames
myCloseBtnNoResult.addEventListener('click', () => {
    myNoResultFrame.classList.add('d-none');
});
// myCloseBtnResult.addEventListener('click', () => {
//     myResultFrame.classList.add('d-none');
// });

// Read data =========================================================================================================================================================================

// Read patient ------------------------------------------------------------------------------
myTrgBtnSubmit.addEventListener('click', (e) => {
    // Prevent submit of form
    e.preventDefault();
    // Reset no/result-frame
    myResultFrame.classList.add('d-none');
    myNoResultFrame.classList.add('d-none');
    // Reset result collapser
    myCollapseBtnResult.classList.remove('fa-circle-plus');
    myResultCode.classList.remove('d-none');
    // Read input value
    let inputValue = myInputSearch.value;

    // Validate clinic ID format
    let expression = /^\d{4}$/;

    if(expression.test(inputValue)) {
        // Input is a 4-digit number
        // Hide error msg
        myErrorMsg.classList.add("d-none");
        // Show loader
        loaderWrapper.classList.remove('d-none');
        // Call some function
        readPatientAPI(inputValue);
    } else {
        // Input is not a 4-digit number
        // Show error msg
        myErrorMsg.classList.remove("d-none");
    }
});

// Read API ----------------------------------------------------------------------------
async function readPatientAPI(inputValue) {

    // let response = await fetch(`${process.env.SELFHELP_API}/clinics/${inputValue}/get-clinic-treatments`, {
        let response = await fetch(`${process.env.NEW_SELFHELP_CLINICS_API}/clinics/${inputValue}/treatments`, {
            method: "GET",
            mode: 'cors',
            headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
    })

    if (response.status != 400 && response.status != 403 && response.status != 404 && response.status != 500 && response.status != 502) {
        let responseParsed = await response.json();

        console.log("API response - Success:");
        console.log(responseParsed);

        parseData(responseParsed);
    } else {
        let responseParsed = await response.json();

        console.log("API response - Error:");
        console.log(responseParsed);

        // Hide loader
        loaderWrapper.classList.add('d-none');
        // Show no result-frame
        myNoResultFrame.querySelector("span").innerHTML = responseParsed.message;
        myNoResultFrame.classList.remove('d-none');
    }
};

function parseData(responseParsed) {
    // Hide loader
    loaderWrapper.classList.add('d-none');

    if (responseParsed.detail.length > 0) {
        // Store treatments in sessionStorage and redirect
        sessionStorage.setItem('treatments', JSON.stringify(responseParsed.detail));
        window.location.href = 'patientsModifyAddTreatment.html'; // change this to your new page URL
    } else {
        // Show NO result
        myNoResultFrame.classList.remove('d-none');
    }
}

